var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6537 4.91812H17.2748V4.08647C17.2748 3.72211 16.974 3.42712 16.6026 3.42712H16.0205C15.649 3.42712 15.3483 3.72211 15.3483 4.08647V4.91812H12.9647V4.08647C12.9647 3.72211 12.664 3.42712 12.2925 3.42712H11.7104C11.339 3.42712 11.0382 3.72211 11.0382 4.08647V4.91812H8.78497V4.08647C8.78497 3.72211 8.48423 3.42712 8.11278 3.42712H7.53066C7.1592 3.42712 6.85847 3.72211 6.85847 4.08647V4.91812H6.34708C5.05109 4.91812 4 5.94911 4 7.22033V18.3101C4 19.5813 5.05109 20.6123 6.34708 20.6123H17.6529C18.9489 20.6123 20 19.5813 20 18.3101V7.22033C20 5.94911 18.9489 4.91812 17.6529 4.91812H17.6537Z",
    fill: "url(#paint0_linear_468_75862)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.685 9.04578C5.685 8.49349 6.13271 8.04578 6.685 8.04578H8.14895C8.70124 8.04578 9.14895 8.49349 9.14895 9.04578V10.5097C9.14895 11.062 8.70124 11.5097 8.14895 11.5097H6.685C6.13271 11.5097 5.685 11.062 5.685 10.5097V9.04578Z",
    fill: "url(#paint1_linear_468_75862)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.685 13.6644C5.685 13.1121 6.13271 12.6644 6.685 12.6644H8.14895C8.70124 12.6644 9.14895 13.1121 9.14895 13.6644V15.1283C9.14895 15.6806 8.70124 16.1283 8.14895 16.1283H6.685C6.13271 16.1283 5.685 15.6806 5.685 15.1283V13.6644Z",
    fill: "url(#paint2_linear_468_75862)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3036 9.04578C10.3036 8.49349 10.7513 8.04578 11.3036 8.04578H12.7676C13.3198 8.04578 13.7675 8.49349 13.7675 9.04578V10.5097C13.7675 11.062 13.3198 11.5097 12.7675 11.5097H11.3036C10.7513 11.5097 10.3036 11.062 10.3036 10.5097V9.04578Z",
    fill: "url(#paint3_linear_468_75862)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3036 13.6644C10.3036 13.1121 10.7513 12.6644 11.3036 12.6644H12.7676C13.3198 12.6644 13.7675 13.1121 13.7675 13.6644V15.1283C13.7675 15.6806 13.3198 16.1283 12.7675 16.1283H11.3036C10.7513 16.1283 10.3036 15.6806 10.3036 15.1283V13.6644Z",
    fill: "url(#paint4_linear_468_75862)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9222 9.04578C14.9222 8.49349 15.3699 8.04578 15.9222 8.04578H17.3861C17.9384 8.04578 18.3861 8.49349 18.3861 9.04578V10.5097C18.3861 11.062 17.9384 11.5097 17.3861 11.5097H15.9222C15.3699 11.5097 14.9222 11.062 14.9222 10.5097V9.04578Z",
    fill: "url(#paint5_linear_468_75862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75862",
    x1: 2.86026,
    y1: 21.5754,
    x2: 22.0598,
    y2: 17.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75862",
    x1: 5.685,
    y1: 12.0872,
    x2: 18.3861,
    y2: 12.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75862",
    x1: 5.685,
    y1: 12.0872,
    x2: 18.3861,
    y2: 12.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_468_75862",
    x1: 5.685,
    y1: 12.0872,
    x2: 18.3861,
    y2: 12.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_468_75862",
    x1: 5.685,
    y1: 12.0872,
    x2: 18.3861,
    y2: 12.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_468_75862",
    x1: 5.685,
    y1: 12.0872,
    x2: 18.3861,
    y2: 12.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorCalendar);
export default __webpack_public_path__ + "static/media/color-calendar.36d7a4ce530db6d442521ba8b43072a7.svg";
export { ForwardRef as ReactComponent };